<template>
  <div id="Home_recommend">
    <div class="recommend_list_oppo">
        <router-link class="item" v-for="item in dataList" :to="productUrl(item)">
          <div class="img" @click="trackClickItem(item.id)" :data-id="item.id" :ref="'category_'+item.id">
            <img v-lazy="replaceImageId(item.category_id)" :alt="item.name">
          </div>
          <div class="T" icon="chevron_right">
            <div class="name">{{item.name}}</div>
          </div>
        </router-link>
    </div>
  </div>
  <feedback />
</template>

<script>
import Oppo from "@/api/oppo";
import Feedback from "@/components/Feedback";
import GTMTrack from "@/api/gtm-track";

export default {
  name: "HomeRecommendOppo",
  components: {Feedback},
  computed:{
    merchantCode(){
      return process.env.VUE_APP_MERCHANT_CODE
    }
  },
  props:{
    dataList:[],
    trace: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      itemInView: [], // 当前在可视区的categoryIds
      itemReported: [], // 已上报过的，不重复上报
      sourceObserver:'',
    }
  },
  watch:{
    dataList:{
      immediate: true,
      deep: true,
      handler(newVal,oldVal){
        if(newVal.length>0){
          this.$nextTick(()=>{
            if(this.dataList.length>0){
              for(let i=0;i<this.dataList.length;i++){
                // add observer
                this.observe(this.dataList[i].id)
              }
            }
          })
        }
      }
    }
  },
  activated() {
    this.itemInView = []
    this.itemReported = []
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    }
    this.sourceObserver = new IntersectionObserver(this.handleIntersection,options)
  },
  beforeDestroy() {
    // const observer = this.$refs.category
    // observer.disconnect()
    if(this.sourceObserver){
      this.sourceObserver.disconnect()
    }
  },
  methods:{
    observe(categoryId){
      if (this.sourceObserver && this.$refs['category_' + categoryId]) {
        this.sourceObserver.observe(this.$refs['category_' + categoryId][0])
      }
    },
    reportObserve(categoryId) {
      if(this.itemReported.includes(categoryId)){
        return;
      }
      setTimeout(() => {
        const index = this.itemInView.indexOf(categoryId);
        if (index !== -1) {
          //console.log('still looking')
          let trace = {...this.trace}
          for (let i = 0; i < this.dataList.length; i++) {
            if (this.dataList[i].id == categoryId) {
              trace.pkg_name = this.dataList[i].name
              trace.card_pos = (i + 1) + ''
              trace.pos = '0'
              break
            }
          }
          this.itemReported.push(categoryId)
          Oppo.trackPageSource(trace)
        } else {
          //console.log('not look')
        }
      }, 1000)
    },
    handleIntersection(entries, ovserver) {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target) {
          // category 进入可见区
          let categoryId = entry.target.getAttribute('data-id')
          //console.log(categoryId + ' move in')
          this.reportObserve(categoryId)
          const index = this.itemInView.indexOf(categoryId);
          if (index === -1) {
            this.itemInView.push(categoryId)
          }
        } else {
          let categoryId = entry.target.getAttribute('data-id')
          //console.log(categoryId + ' move out')
          const index = this.itemInView.indexOf(categoryId); // 获取要移除元素的索引
          if (index !== -1) {
            this.itemInView.splice(index, 1); // 从数组中移除一个元素
          }
        }
      })
    },
    trackClickItem(id) {
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].id == id) {
          let trace = {...this.trace}
          trace.card_pos = (i + 1) + ''
          trace.pos = (i + 1) + ''
          trace.click_type = 'Product List'
          trace.card_info = this.dataList[i].name
          Oppo.trackClickGameCard(trace)
          GTMTrack.clickCategory(this.dataList[i].name)
          break
        }
      }
    },
    productUrl(category) {
      if (category.mode === 'pin') {
        return '/card/' + category.code
      }
      if (category.mode === 'directtopup') {
        return '/direct-top-up/' + category.code
      }
      return '/'
    },
    replaceImageId(id) {
      // return 'https://seagm-media.seagmcdn.com/mini_store/art-oppo/home_recommend/756.jpg?x-oss-process=image/resize,w_654,limit_0'
      return process.env.VUE_APP_HOME_PRODUCT_IMG_URL.replace('img_id', id)
    }
  }
}
</script>

<style scoped>

</style>
